export default {
   init() {

      const blockNews = document.querySelector('.block-news');
      if (!blockNews) return;

      const loadMoreWrap = blockNews.querySelector('.news-loadmore__wrap');
      const btnLoadMore = loadMoreWrap.querySelector('.news-loadmore-btn');
      const loading = blockNews.querySelector('.in-progress');
      const results = blockNews.querySelector('.block-news__results');
      const query = results.dataset.query;

      function fetchData() {
         const paged = results.dataset.currentpage;

         const eventParams = {
            action: "loadmore_news",
            query: query,
            paged: paged
         };

         fetch(block_script.ajax_url, {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: new URLSearchParams({ ...eventParams })
         })
            .then(response => response.json())
            .then(data => handleFetchSuccess(data))
            .catch(error => console.error("AJAX Error:", error));
      }

      function handleFetchSuccess(data) {
         results.insertAdjacentHTML('beforeend', data.data.items);

         if (loadMoreWrap) {
            loadMoreWrap.classList.remove('__in-progress');
            loadMoreWrap.style.display = data.data.has_more ? 'block' : 'none';
         }
      }

      // Event Listeners
      if (btnLoadMore) {
         btnLoadMore.addEventListener('click', () => {
            const currentpage = results.dataset.currentpage;
            results.dataset.currentpage = parseInt(currentpage) + 1;
            loadMoreWrap.classList.add('__in-progress');
            fetchData();
         });
      }
   }
}